import { normalizeLobbyPeerEntry } from './lobbyMesh.js';

const CACHE_KEY = 'dechess-lobby-directory-v1';
const CACHE_MAX_AGE_MS = 10 * 60 * 1000;

export function loadCachedLobbyDirectory({
  selfPeerId = '',
  selfPlayerId = '',
  now = Date.now()
} = {}) {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.peers)) {
      return [];
    }
    if (typeof parsed.savedAt !== 'number' || now - parsed.savedAt > CACHE_MAX_AGE_MS) {
      return [];
    }
    return parsed.peers
      .map((entry) => normalizeLobbyPeerEntry(entry, now))
      .filter((entry) => (
        entry
        && entry.peerId !== selfPeerId
        && (!selfPlayerId
          || String(entry.playerId || '').toLowerCase() !== String(selfPlayerId).toLowerCase())
      ));
  } catch {
    return [];
  }
}

export function saveCachedLobbyDirectory(peers = [], { now = Date.now() } = {}) {
  try {
    const compact = (peers || [])
      .map((entry) => normalizeLobbyPeerEntry(entry, now))
      .filter(Boolean)
      .slice(0, 100)
      .map((entry) => ({
        peerId: entry.peerId,
        playerId: entry.playerId,
        nickname: entry.nickname,
        country: entry.country,
        openToChallenges: entry.openToChallenges,
        archivist: Boolean(entry.archivist),
        lastSeenAt: entry.lastSeenAt
      }));
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({
      savedAt: now,
      peers: compact
    }));
  } catch {
    // Ignore quota / private-mode failures.
  }
}
